import { type FC } from 'react';

import { Text } from '@eneco/sparky';

import { Overview } from '../Overview/Overview';

interface Props {
  title?: string;
  productLabel?: string;
  productName?: string;
  reasonTitle?: string;
  reason?: string;
  explanation?: string;
}

/**
 * What a cancellation flow's summary says the visitor cancels and why: the product, then the reason they chose in the
 * reason step, followed by their own explanation when they gave one.
 */
export const CancellationOverview: FC<Props> = ({
  title,
  productLabel,
  productName,
  reasonTitle,
  reason,
  explanation,
}) => (
  <Overview>
    <Overview.Header>{title}</Overview.Header>
    <Overview.Details type="situation" title={productLabel ?? ''}>
      <Text as="p"> {productName}</Text>
    </Overview.Details>

    <Overview.Details type="situation" title={reasonTitle ?? ''}>
      <Text as="p">
        {reason}
        {explanation ? `- ${explanation}` : ''}
      </Text>
    </Overview.Details>
  </Overview>
);
